import Jobdetails from './Jobdetails';
import Exchangecabledetails from './Exchangecabledetails'
import { useSearchParams, useLocation } from 'react-router-dom';
import { BreadCrumbContext } from '../common/BreadCrumbContext';
import { useEffect, useContext,useState } from 'react';

const ExchangeView = () => {

  /** assigining searchparams */
  const [searchParams] = useSearchParams();
  const css = (searchParams.get('css'));
  const exch_sau = (searchParams.get('exch_sau'));
  const exchange = (searchParams.get('exchange'));
  const [refreshKey, setRefreshKey] = useState(0); 

  const [mucjChecked, setMucjChecked] = useState(() => {
    const storedValue = sessionStorage.getItem('mucjChecked');
    return storedValue ? JSON.parse(storedValue) : false; 
});

useEffect(() => {
    sessionStorage.setItem('mucjChecked', JSON.stringify(mucjChecked));
}, [mucjChecked]);

useEffect(() => {
    return () => {
        sessionStorage.removeItem('mucjChecked'); // Clears when component unmounts
    };
}, []);

  /** Breadcrum */
  const { pathList, setPathList } = useContext(BreadCrumbContext);
  const location = useLocation();
  useEffect(() => {
    let updatedList = pathList.map(item => {
      (item.pathname === 'exchange') && (item.search = location.search)
      return item;
    });
    setPathList(updatedList)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setPathList(pathList?.filter((item) => item.pathname !== 'jumper_schedule'));
    // eslint-disable-next-line
  }, [])
 

  return (
    <div>
      <Jobdetails exchange={exchange} mucjChecked={mucjChecked} setRefreshKey={setRefreshKey}/>
      <Exchangecabledetails css={css} exch_sau={exch_sau} exchange={exchange} mucjChecked={mucjChecked} setMucjChecked={setMucjChecked} refreshKey={refreshKey}/>
    </div>
  )
}

export default ExchangeView